import useBillingPortal from './useBillingPortal';

const DEFAULT_CLASSES = "px-6 py-2.5 bg-[#38433A] text-white rounded-lg hover:bg-[#2C352E] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

const ManageBillingButton = ({ label = 'Manage Billing', className, icon: Icon }) => {
    const { openPortal, isLoading, error } = useBillingPortal();

    return (
        <div>
            <button
                type="button"
                onClick={openPortal}
                disabled={isLoading}
                className={className || DEFAULT_CLASSES}
            >
                {Icon && <Icon className="w-4 h-4 shrink-0" strokeWidth={1.75} />}
                {isLoading ? 'Redirecting…' : label}
            </button>
            {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
        </div>
    );
};

export default ManageBillingButton;
